import { ReactNode } from 'react';
import { Stack } from '@chakra-ui/react';

interface DownloadOptionWrapperProps {
  condition: boolean;
  children: ReactNode;
}

export const DownloadOptionWrapper = ({ condition, children }: DownloadOptionWrapperProps) => {
  if (condition)
    return (
      <Stack
        border='1px solid'
        borderColor='gray.200'
        borderRadius='base'
        p='2'
        spacing='0'
        data-testid='gate-download-wrapper'
      >
        {children}
      </Stack>
    );
  return <>{children}</>;
};
